// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import global from './common/global.js'
// import {initws,webSockeObj,formatDate} from './common/webSocket.js'
import ls from './common/localStorage.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// import iNotify from 'title-notify';
// 全局图标
import './icons'

Vue.use(ElementUI)
// Vue.use(iNotify)


import axios from 'axios'
import Qs from 'qs'

Vue.prototype.axios = axios;
Vue.prototype.qs = Qs;
Vue.prototype.ls = ls;
Vue.prototype.global = global;
Vue.prototype.globalData = global.globalData;
Vue.prototype.formatDate = global.formatDate;
Vue.prototype.$bus = new Vue()


// Vue.prototype.initws = initws;
// Vue.prototype.webSockeObj = webSockeObj;
// Vue.prototype.formatDate = formatDate;


//axios.defaults.timeout=1000,
//默认的contenttype为json以及utf-8；
//axios.defaults.headers={'Content-Type': 'text/html;charset=gb2312'}
//axios.defaults.baseURL = 'http://127.0.0.1:3001';
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js